  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.tabs__link');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');

        // Remove current class from all tabs and contents
        tabs.forEach(function(tab) {
          tab.classList.remove('current');
          document.getElementById(tab.getAttribute('data-tab')).classList.remove('current');
        });

        // Add current class to clicked tab and corresponding content
        this.classList.add('current');
        document.getElementById(tabId).classList.add('current');
      });
    });
  });